module.exports = __webpack_public_path__ + "img/Screenshot_menu_basic_data.34607760.png";